<template>
    <b-card>
        <b-card-header>Posta in debiteringshändelser</b-card-header>
        <b-card-body>
            <!-- <b-row>
                <b-col cols="4">
                    <b-form-select class="form-control" v-model="newEvent.EventTypeId" :options="GetEventTypes()">
                    </b-form-select>
                </b-col>
            </b-row> -->
            <b-row>
                <b-col>
                    <tableedit v-if="editMode" v-bind:recs="recs" v-bind:cols="fields" v-bind:readonly="!editMode"
                    savebuttontext="Posta in debiteringar"
                    cancelHidden="true" @save="onSave" @cancel="onCancel">
                    </tableedit>
                </b-col>
            </b-row>

        </b-card-body>
    </b-card>
</template>
<script>
import tableedit from "../logic/tableedit";
import { Api } from "../../lib/api";
const api = new Api();

export default {
    name: 'registerdebitevents',
    components: { tableedit },
    data() {
        return {
            recs: [],
            editMode: true,
            fields: [
                { id: 0, caption: "SändningsID", field: "tspDocNo", type: "text", items: null },
                { id: 1, caption: "Kommentar", field: "comment", type: "text", items: null },
                { id: 2, caption: "Produktkod", field: "productKey", type: "text", items: null },
                { id: 3, caption: "Belopp", field: "revisedCost", type: "string", items: null },
                { id: 4, caption: "Resultat", field: "result", type: "string", items: null },
            ]
        }
    },
    methods: {
        onSave(r) {
            if(confirm("Vill du posta in debiteringsinformationen?")) {
                var dt = [];
                r.forEach(x => {
                    if(x && x.revisedCost) {
                        dt.push({tspDocNo: x.tspDocNo, comment: x.comment, productKey: x.productKey, revisedCost: Number(String(x.revisedCost)
                            .replace(' ','')
                            .replace(',','.'))});
                    }
                });
                if(dt.length==0) {
                    alert('Finns inga poster att lägga in.');
                    return;
                }
                //var dt = r.map(x => { return {tspDocNo: x.tspDocNo, comment: x.comment, productKey: x.productKey, revisedCost: Number(x.revisedCost.replace(',','.'))}});
                api.post('/api/debit/registerdebitevents',dt).then(res => {
                    this.recs = res.data;
                    alert('Debiteringar behandlade. Se resultat i resultatkolumnen.')
                });
            }
            
        },
        onCancel(r) {
            if(confirm("Vill du avbryta?")) {
                this.recs = [];
            }
        }
    }
}
</script>